// FATE: Fantastic Adventure Text Engine (front end) 0.1 Alpha 
// © John Hiner 2022


import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'

createApp(App).mount('#app')
